<template>
    <div class="divCer" :style="{height: divHeight+'px', width: divWidth+'px'}">
        <img :src="imgUrl" alt="" class="imgCer" @mouseenter="imgEnter">
        <div class="divMask" v-if="maskIsShow" @mouseleave="maskLeave">
            <i class="iconfont icon-shanchu iCerDel" :style="{top:iTop+'px', left:iLeft+'px'}" @click="remove"></i>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SubImg',
    props: ['url', 'height', 'width'],
    created () {
        let height = 120
        if (this.height) {
            height = this.height
        }
        this.divHeight = height
        this.iTop = height / 2 - 20
        let width = 200
        if (this.width) {
            width = this.width
        }
        this.divWidth = width
        this.iLeft = width / 2 - 10
        this.imgUrl = this.url
    },
    data () {
        return {
            divHeight: 0,
            divWidth: 0,
            iTop: 0,
            iLeft: 0,
            maskIsShow: false,
            imgUrl: ''
        }
    },
    methods: {
        imgEnter () {
            this.maskIsShow = true
        },
        maskLeave () {
            this.maskIsShow = false
        },
        remove () {
            this.$emit('delete', this.url)
        }
    }
}
</script>

<style scoped>
.divCer {
    position: relative;
    text-align: center;
}

.divMask {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    border-radius: 5px;
    text-align: center;
}

.imgCer {
    width: 100%;
    height: 100%;
    border-radius: 5px;
}

.iCerDel {
    position: absolute;
    cursor: pointer;
    color: #ffffff;
    font-size: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/public/sub/SubImg.vue